/*
 * Lib Module Tables
 */

Lib.Table = (function() {
    const self = {};

    // Document ready
    $(Lib).on('document.ready', function() {
        $(document).on('click', 'table tr[data-rowlink]:not([data-rowlink=""]) td:not(.actions):not([data-norowlink])', function(e) {
            let url = $(this).parent().data('rowlink');
            if (url !== '') {
                let _blank = e.altKey || $(this).parent().data('rowlink-target') === '_blank';

                if (!_blank) {
                    $(this).parent().addClass('activated-rowlink');
                }

                Lib.Util.redirect(url, false, false, _blank);
            }
        });

        $(document).on('mousedown', 'table tr[data-rowlink]:not([data-rowlink=""]) td:not(.actions):not([data-norowlink])', function(e) {

            // Middle click
            if (e.which != 2) {
                return true;
            }

            let url = $(this).parent().data('rowlink');
            if (!url) {
                return true;
            }

            Lib.Util.redirect(url, false, false, true);

            return false;
        });

        $(document).on('click', '[data-norowlink]', function(e) {
            e.stopPropagation();
        });

    });

    $(Lib).on('after.document.ready', function() {

        // Highlight multiple
        $(document).on({
            mouseenter: function() {
                let highlight_id = $(this).data('highlight-multiple');
                let rows = $('tr[data-highlight-multiple=\'' + highlight_id + '\']');
                if (rows.length > 1) {
                    rows.addClass('highlight-multiple-hover');
                }
            },
            mouseleave: function() {
                //stuff to do on mouse leave
                let highlight_id = $(this).data('highlight-multiple');
                $('tr[data-highlight-multiple=\'' + highlight_id + '\']').removeClass('highlight-multiple-hover');
            }
        }, 'tr[data-highlight-multiple]');

        /**
         * Row selection
         * @type {*|jQuery.fn.init|jQuery|HTMLElement}
         */
        $(document).on('change', 'input[data-row-selection]', function() {

            let rowSelectionCheckboxEls = $('input[data-row-selection]');

            if ($(this).is(':checked')) {
                $(this).closest('tr').addClass('row-selected');
            } else {
                $(this).closest('tr').removeClass('row-selected');
            }

            let hasSelectedRows = false;
            if (rowSelectionCheckboxEls.filter(':checked').length) {
                $(this).closest('table').addClass('table-has-rows-selected');
                hasSelectedRows = true;
            } else {
                $(this).closest('table').removeClass('table-has-rows-selected');
            }

            self.redrawHighlightMultipleOr();

        });

        /**
         * Select all checkboxes
         */
        $(document).on('change', 'input[data-tbody-select-all]', function() {
            let selectAllIdentifier = $(this).data('tbody-select-all');
            let partnerBody = $('tbody[data-tbody-select-all="' + selectAllIdentifier + '"]');
            if ($(this).is(':checked')) {
                partnerBody.find('tr td input:checkbox:not([data-no-select-all])').prop('checked', 1).trigger('change');
            } else {
                partnerBody.find('tr td input:checkbox:not([data-no-select-all])').prop('checked', 0).trigger('change');
            }

        });

        /**
         * Checkboxes inside a select-all tbody
         */
        $(document).on('change', 'tbody[data-tbody-select-all] input:checkbox:not([data-no-select-all])', function() {

            let selectAllTbody = $(this).closest('tbody');
            let selectAllIdentifier = selectAllTbody.data('tbody-select-all');
            let partnerSelectAll = $('input[data-tbody-select-all="' + selectAllIdentifier + '"]:checkbox');

            let allCheckboxes = selectAllTbody.find('tr td input:checkbox');
            let selectedCheckboxes = allCheckboxes.filter(':checked');

            // See if we checked all the checkboxes in this table
            if (allCheckboxes.length === selectedCheckboxes.length) {
                partnerSelectAll.prop('checked', 1);
            } else {
                partnerSelectAll.prop('checked', 0);
            }
        });
    });

    let highlightMultipleOrIndex = {};
    self.highlightMultipleOr = function(index) {

        if (index) {
            self.setHighlightMultipleOrIndex(index, true);
        }

        let highlightedRows = [];

        $(document).on({
            mouseenter: function() {

                let identifier = $(this).data('highlight-multiple-or-identifier');

                let selector = [];
                $.each(highlightMultipleOrIndex[identifier], function(k, highlightMultipleOrIdentifier) {
                    selector.push(`tr[data-highlight-multiple-or-identifier="${highlightMultipleOrIdentifier}"]`);
                });

                if (selector.length > 0) {

                    let matchedRows = $(selector.join(',')).add($(this));

                    let currentTableHasSelectedRows = $('table.table-has-rows-selected').length > 0;
                    if (currentTableHasSelectedRows) {
                        matchedRows = matchedRows.filter('.row-selected');
                    }

                    if ((!currentTableHasSelectedRows && matchedRows.length > 1) || (currentTableHasSelectedRows && (matchedRows.length > 1 || matchedRows.length === 1 && !matchedRows.is($(this))))) {
                        highlightedRows = matchedRows.addClass('highlight-multiple-hover');
                    }
                }

            },
            mouseleave: function() {
                if (highlightedRows.length) {
                    highlightedRows.removeClass('highlight-multiple-hover');
                    highlightedRows = [];
                }
            }
        }, 'tr[data-highlight-multiple-or-identifier]');

    };

    self.redrawHighlightMultipleOr = function() {

        Lib.Debounce(function() {

            $('tr.highlight-multiple-or-on-pageload').removeClass('highlight-multiple-or-on-pageload');

            let highlightMultipleOrIdentifiers = [];

            if ($('table.table-has-rows-selected').length > 0) {

                $('tr[data-highlight-multiple-or-identifier].row-selected').each(function() {
                    let currentIdentifier = $(this).data('highlight-multiple-or-identifier');
                    if (self.highlightMultipleOrHasMatchesSelected(currentIdentifier)) {
                        highlightMultipleOrIdentifiers.push(currentIdentifier);
                    }
                });
            } else {
                highlightMultipleOrIdentifiers = Object.keys(highlightMultipleOrIndex);
            }

            let selector = [];

            $.each(highlightMultipleOrIdentifiers, function(k, highlightMultipleOrIdentifier) {
                selector.push(`tr[data-highlight-multiple-or-identifier="${highlightMultipleOrIdentifier}"]`);
            });

            let matchedRows = $(selector.join(','));
            matchedRows.addClass('highlight-multiple-or-on-pageload');

        }, 200, 'highlight-multiple-or');

    };

    self.highlightMultipleOrHasMatchesSelected = function(identifier) {

        let hasSelected = false;

        $.each(highlightMultipleOrIndex[identifier], function(k, highlightMultipleOrIdentifier) {

            if ($(`tr[data-highlight-multiple-or-identifier="${highlightMultipleOrIdentifier}"].row-selected`).length === 1) {

                hasSelected = true;

                // Break the $.each
                return false;
            }
        });

        return hasSelected;
    };

    /**
     *
     * @param index
     * @param redraw
     */
    self.setHighlightMultipleOrIndex = function(index, redraw) {

        highlightMultipleOrIndex = index;
        redraw = typeof redraw === 'undefined' ? true : redraw;

        if (redraw) {
            self.redrawHighlightMultipleOr();
        }
    };

    return self;

})();
